/** 商品封面：闲鱼 CDN 常见为 .heic，多数浏览器无法直接解码，失败时尝试 .jpg */
export function normalizeItemCoverUrl(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') return '';
  let u = url.trim();
  if (!u) return '';
  if (u.startsWith('//')) u = 'https:' + u;
  else if (u.startsWith('http://')) u = 'https://' + u.slice(7);
  return u;
}

export function itemCoverFallbackUrl(current: string): string | null {
  if (!current) return null;
  if (/\.heic(\?|$)/i.test(current)) {
    return current.replace(/\.heic(\?|$)/i, '.jpg$1');
  }
  return null;
}
